export const HOUR_HEIGHT = '10rem'
export const HOUR_WIDTH = '10rem'
export const HOURS = ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'] 
export const DAY_HEIGHT = '80px'
export const DAYS_OF_WEEK = [ "SUN", "MON", "TUES", "WED", "THURS", "FRI", "SAT" ]